/* global jQuery */
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { getPosts } from '../components/getPosts';
import { addActiveOption, handleDisableFilter, handleRestart } from '../components/activeFilters';

gsap.registerPlugin(ScrollTrigger);
const $ = jQuery;
const $section = $('section.publications-archive');
const postContainer = $section.find('.js-archive--posts');
let cachedExternalCardHtml = '';
let isLoadMore = false;
const loadMoreScrollTrigger = null;

const cacheExternalCard = () => {
	const $first = postContainer.children().first();
	if ($first.length && $first.hasClass('js-archive--external-card')) {
		cachedExternalCardHtml = $first.prop('outerHTML');
	}
};

const getTotalPosts = () => {
	if (!postContainer.length) return 0;
	return postContainer.find('.card-publication').length;
};

const handleLocations = ($option) => {
	if ($option.closest('.filter-dropdown').data('name') !== 'instance') return;

	const $locationDropdown = $('.filter-dropdown[data-name="location"]');
	if ($option.data('locations')) {
		$locationDropdown.find('.filter-dropdown__container').slideDown(200);

		setTimeout(() => {
			$locationDropdown.removeClass('disabled');
		}, 100);
	} else {
		$locationDropdown.addClass('disabled');
		$locationDropdown.find('.filter-dropdown__container').slideUp(200);
	}
};

const handleAllFiltersDropdown = () => {
	const $dropdowns = $section.find('.publications-archive__all-filters');
	const $button = $('.js-trigger-all-filters');
	if (!$dropdowns.length || !$button.length) return;

	$button.on('click', function () {
		$(this).toggleClass('active');
		$dropdowns.slideToggle();

		const $buttonTitle = $(this).find('.publications-archive__button-title');
		const textOpen = $buttonTitle.data('text-open');
		const textClose = $buttonTitle.data('text-close');

		if ($(this).hasClass('active')) {
			$buttonTitle.text(textClose);
		} else {
			$buttonTitle.text(textOpen);
		}
	});
};

const getActiveFilterData = () => {
	const filters = [];
	const $filters = $section.find('.js-filter-dropdown');

	$filters.each(function () {
		const $filter = $(this);
		if ($filter.hasClass('disabled')) return;

		const $activeOption = $filter.find('.js-filter-dropdown--option.selected');
		const name = $filter.data('name');
		const value = $activeOption.data('value');

		filters.push({
			name,
			value,
		});
	});

	return filters;
};

const getActiveSearchData = () => {
	const $input = $section.find('.js-archive--search input');
	const searchData = $input.val();
	return searchData;
};

const getPinnedIds = () => {
	const pinnedIds = $section.data('pinned-ids');
	if (!pinnedIds) return [];
	return String(pinnedIds)
		.split(',')
		.map((id) => id.trim())
		.filter(Boolean);
};

const hasExternalCard = () => {
	return $section.data('has-external-card') === 1 || $section.data('has-external-card') === '1';
};

const handlePostsBefore = () => {
	postContainer.addClass('loading');
};

const disableLoadMoreGsap = () => {
	if (loadMoreScrollTrigger) {
		loadMoreScrollTrigger.kill();
	}
};

const toPostsHtml = (posts) => {
	if (!posts) return '';
	return Array.isArray(posts) ? posts.join('') : posts;
};

const handleSuccess = (data) => {
	const parsedData = JSON.parse(data);
	const $loadMoreButton = $section.find('.js-load-more');
	const postsHtml = toPostsHtml(parsedData.posts);

	if (!isLoadMore) {
		if (!parsedData.posts) {
			postContainer.html(cachedExternalCardHtml);
			$loadMoreButton.hide();
		} else {
			postContainer.html(cachedExternalCardHtml + postsHtml);
			if (parsedData.total > getTotalPosts()) {
				$loadMoreButton.css('display', 'inline-flex');
			} else {
				$loadMoreButton.hide();
				disableLoadMoreGsap();
			}
		}
	} else if (!parsedData.noResult) {
		postContainer.append(postsHtml);
		if (parsedData.total <= getTotalPosts()) {
			$loadMoreButton.hide();
			disableLoadMoreGsap();
		}
	} else {
		$loadMoreButton.hide();
		disableLoadMoreGsap();
	}

	postContainer.removeClass('loading');
	ScrollTrigger.refresh();
};

const handlePosts = (loadMore = false, postIds = []) => {
	isLoadMore = loadMore;
	const data = {
		action: 'get_publications',
		taxonomies: getActiveFilterData(),
		search: getActiveSearchData(),
		postIds,
		pinnedIds: getPinnedIds(),
		hasExternalCard: hasExternalCard() ? 1 : 0,
	};

	getPosts(data, handlePostsBefore, handleSuccess);
};

const handleSearchTrigger = () => {
	let debounceTimer;

	$section.find('.js-archive--search input').on('keyup', (e) => {
		const query = $(e.currentTarget).val().trim();

		if (e.key === 'Enter') {
			handlePosts();
			return;
		}

		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => {
			if (query.length > 3 || query.length === 0) {
				handlePosts();
			}
		}, 300);
	});
};

const handleLoadMore = () => {
	const $loadMoreButton = $section.find('.js-load-more');
	if (!$loadMoreButton.length) return;

	$loadMoreButton.on('click', () => {
		const $posts = postContainer.find('.card-publication');
		const postIds = $posts
			.map(function () {
				return $(this).data('id');
			})
			.get();

		if (postContainer.hasClass('loading')) return;
		handlePosts(true, postIds);
	});
};

export default function () {
	if (!$section.length) return;

	cacheExternalCard();

	const $options = $section.find('.js-filter-dropdown--option');
	if (!$options.length) return;

	handleAllFiltersDropdown();
	handleSearchTrigger();
	handleLoadMore();
	handleRestart(handlePosts);
	handleDisableFilter(handlePosts);

	$options.on('click', function () {
		handleLocations($(this));
		handlePosts();
		addActiveOption($(this));
	});
}
